<template>
	<div class="map-part">
		<title1 title="运营指标" subTitle="Operation Index" />
		<div class="contion">
			<div class="item">
				<div class="parents_box">
					<img class="itemImg" src="@/assets/images/index/double_title.png" />
					<p>{{ satationData.cur_month_num }}</p>
					<p class="nowrap">本月充换电次数</p>
				</div>
				<div class="parents_box">
					<img class="itemImg" src="@/assets/images/index/double_title.png" />
					<p>{{ satationData.cur_month_elect }}</p>
					<p class="nowrap">本月充换电电量</p>
				</div>
				<div class="parents_box">
					<img class="itemImg" src="@/assets/images/index/double_title.png" />
					<p>{{ satationData.cur_month_mileage }}</p>
					<p class="nowrap">本月充换电里程</p>
				</div>
			</div>
			<div class="box1">
				<divBox title="充换电次数">
					<myEchart v-if="showcdata1" :id="'changeNumber'" :options="cdata1" />
				</divBox>
			</div>
			<div class="box1">
				<divBox title="充换电电量">
					<myEchart v-if="showcdata2" :id="'changeElectricityMeasure'" :options="cdata2" />
				</divBox>
			</div>
			<div class="box1">
				<divBox title="行驶里程">
					<myEchart v-if="showcdata3" :id="'changeMiles'" :options="cdata3" />
				</divBox>
			</div>
		</div>
	</div>
</template>

<script>
import infoList from "../infoList";
import divBox from "./divbox2";
import myEchart from "../charts/echarts";
import { dataInterface } from "@/api/dataInterfaceApi";
import title1 from "@/views/exposition/components/title1";
import * as echarts from "echarts5";

export default {
	components: {
		myEchart,
		divBox,
		infoList,
		title1,
	},
	data() {
		return {
			bigtitle: {
				CHN: "运营指标",
				ENG: "Traffic indicators",
			},
			//  充换电次数
			showcdata1: false,
			cdata1: {
				title: {
					text: "次",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				legend: {
					right: "left",
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: "#fff",
					},
				},
				xAxis: {
					type: "category",
					boundaryGap: false,
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				series: [],
			},
			showcdata2: false,
			// title:"充换电电量",
			cdata2: {
				title: {
					text: "Kwh",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				legend: {
					right: "left",
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: "#fff",
					},
				},
				xAxis: {
					type: "category",
					boundaryGap: false,
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				legendData: [{
						// name: "新增数",
						icon: "roundRect",
					},
					{
						// name: "活跃数",
						icon: "roundRect",
					},
				],
				series: [],
			},
			showcdata3: false,
			// title:"行驶里程",
			cdata3: {
				title: {
					text: "km",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				legend: {
					hidden: true
				},
				xAxis: {
					type: "category",
					boundaryGap: false,
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				legendData: [{
						// name:"新增数",
						icon: "roundRect",
					},
					{
						// name:"活跃数",
						icon: "roundRect",
					},
				],
				series: [],
			},
			satationData: {},
		};
	},
	props: {
		// cdata: {
		//   type: Object,
		//   default: () => ({}),
		// },
	},
	watch: {},
	mounted() {
		// 充换电次数
		this.getBattery1();
		// 充换电电量
		this.getBattery2();
		// 行驶里程
		this.getBattery3();
		// 运营指标
		this.getOperational();
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log("sf123123123123123123123", data);
		},
		//充换电次数
		getBattery1() {
			let params = {
				enCode: "per_vehicle-充换电次数",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || "LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data1 = [];
						let data2 = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date);
							data1.push(item.daily_exchange_num);
							data2.push(item.daily_charge_num);
						});
						let series1 = {
							name: "换电次数",
							type: "line",
							// stack: 'Total',
							smooth: true,
							areaStyle: {
								normal: {
									color: {
										type: "linear",
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
												offset: 0.1,
												color: "#11518D", // 0% 处的颜色
											},
											{
												offset: 0.9,
												color: "#192F42", // 100% 处的颜色
											},
										],
										globalCoord: false, // 缺省为 false
									},
								},
							},
							itemStyle: {
								normal: {
									color: "#11C1E3",
								},
							},
							showSymbol: false,
						};
						let series2 = {
							name: "充电次数",
							type: "line",
							// stack: 'Total',
							smooth: true,
							itemStyle: {
								normal: {
									color: "#34CE84",
								},
							},
							showSymbol: false,
							areaStyle: {
								normal: {
									color: {
										type: "linear",
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
												offset: 0.1,
												color: "#298E66", // 0% 处的颜色
											},
											{
												offset: 0.9,
												color: "#184B37", // 100% 处的颜色
											},
										],
										globalCoord: false, // 缺省为 false
									},
								},
							},
						};
						this.cdata1.xAxis.data = xAxis;
						series1.data = data1;
						this.cdata1.series.push(series1);
						series2.data = data2;
						this.cdata1.series.push(series2);
						this.showcdata1 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//充换电电量
		getBattery2() {
			let params = {
				enCode: "per_vehicle-充换电电量",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || "LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data1 = [];
						let data2 = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date);
							data1.push(item.exchange_elect);
							data2.push(item.charge_elect);
						});
						let series1 = {
							name: "充电电量",
							type: "line",
							// stack: 'Total',
							smooth: true,
							itemStyle: {
								normal: {
									color: "#0CA7C6",
								},
							},
							showSymbol: false,
							areaStyle: {
								normal: {
									color: {
										type: "linear",
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
												offset: 0.1,
												color: "#8FD7D9", // 0% 处的颜色
											},
											{
												offset: 0.9,
												color: "#1B344B", // 100% 处的颜色
											},
										],
										globalCoord: false, // 缺省为 false
									},
								},
							},
						};
						let series2 = {
							name: "换电电量",
							type: "line",
							// stack: 'Total',
							smooth: true,
							itemStyle: {
								normal: {
									color: "#80F1F3",
								},
							},
							showSymbol: false,
							areaStyle: {
								normal: {
									color: {
										type: "linear",
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
												offset: 0.1,
												color: "#5CB2BA", // 0% 处的颜色
											},
											{
												offset: 0.9,
												color: "#5F8688         ", // 100% 处的颜色
											},
										],
										globalCoord: false, // 缺省为 false
									},
								},
							},
						};
						this.cdata2.xAxis.data = xAxis;
						series1.data = data1;
						this.cdata2.series.push(series1);
						series2.data = data2;
						this.cdata2.series.push(series2);
						this.showcdata2 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//获取24小时电次数分布
		getBattery3() {
			let params = {
				enCode: "per_vehicle-行驶里程-全国车辆均值",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let series1 = {
							name: "行驶里程",
							type: "line",
							stack: "Total",
							smooth: true,
							lineStyle: {
								width: 2,
								color: "#3689E3",
							},
							showSymbol: false,
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#3689E3", //改变折线点的颜色
								},
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#0C3963",
									},
									{
										offset: 1,
										color: "#112332",
									},
								]),
							},
						};
						let series2 = {
							name: "车辆行驶里程均值",
							type: "line",
							stack: "Total",
							smooth: true,
							lineStyle: {
								width: 2,
								color: "#73E7AD",
							},
							showSymbol: false,
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#73E7AD", //改变折线点的颜色
								},
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#298E66",
									},
									{
										offset: 1,
										color: "#103325",
									},
								]),
							},
						};
						let data1 = [];
						let data2 = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date);
							data1.push(item.driver_mileage);
							data2.push(item.avg_diver_mileage);
						});
						this.cdata3.xAxis.data = xAxis;
						series1.data = data2;
						this.cdata3.series.push(series1);
						series2.data = data1;
						this.cdata3.series.push(series2);
						this.showcdata3 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		// 获取运营指标
		getOperational() {
			let params = {
				enCode: "per_vehicle-运营指标",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						console.log(res, "运营指标");
						this.satationData = res[0] || {};
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
// @import './part.scss';
.contion {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

	// flex-wrap: wrap;
	// align-content: stretch;
	// justify-content: space-between;
	.item {
		padding: 50px 0 42px 0;
		display: flex;
		justify-content: space-around;

		.parents_box {
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 30px;

			.itemImg {
				margin-top: 20px;
				width: 100px;
				height: auto;
			}

			.nowrap {
				white-space: nowrap;
				margin-top: 15px;
				font-size: 12px;
			}
		}
	}
}

.box {
	width: 430px;
	height: 370px;
}

.box1 {
	width: 430px;
	height: 340px;
	margin-top: 20px;
}
</style>
